<template>
  <div class="xpage-tabs">
    <template v-for="(tab, index) in applicationTabs" :key="index">
      <PermissionsWrapper
        v-if="tab.permissionId"
        :permissionIds="[Permissions[tab.permissionId]]"
        :permissionLevel="tab.permissionLevel"
      >
        <button
          @click="changeTab(tab.identifier)"
          :class="{ xselected: tab.isTabActive }"
        >
          <TabStatusIcon :status="tab.tabStatus" />
          {{ tab.name }}
        </button>
      </PermissionsWrapper>
      <PermissionsWrapper v-else :permissionLevel="tab.permissionLevel">
        <button
          @click="changeTab(tab.identifier)"
          :class="{ xselected: tab.isTabActive }"
        >
          <TabStatusIcon :status="tab.tabStatus" />
          {{ tab.name }}
        </button>
      </PermissionsWrapper>
    </template>
  </div>
</template>

<script setup lang="ts">
import { Permissions } from "@/models/permissions";
import PermissionsWrapper from "@/components/wrappers/PermissionsWrapper.vue";
import TabStatusIcon from "@/components/v2/tabs/TabStatusIcon.vue";
import { storeToRefs } from "pinia";
import { useApplicationStore } from "@/store/store/applicationVMStore";

const store = useApplicationStore();

const { applicationTabs } = storeToRefs(store);


const emit = defineEmits<{
  (e: "openTab", identifier: string): void;
}>();

const changeTab = (identifier: string) => {
  store.updateActiveTab(identifier);
	emit("openTab", identifier);
};
</script>
